import { render } from "./SdsSurvey.vue?vue&type=template&id=39eec10e&scoped=true"
import script from "./SdsSurvey.vue?vue&type=script&lang=js"
export * from "./SdsSurvey.vue?vue&type=script&lang=js"

import "./SdsSurvey.vue?vue&type=style&index=0&id=39eec10e&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eec10e"]])

export default __exports__